const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/push/v1frontend/pushns/search', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
